const BANK_DEPOSIT_ROUNDING_INCREMENT_CENTS = 1000;

const toCurrencyNumber = (value) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return 0;
  return Math.round((numericValue + Number.EPSILON) * 100) / 100;
};

export const roundBankDepositAmount = (amount) => {
  const numericAmount = toCurrencyNumber(amount);
  if (numericAmount <= 0) return 0;

  const cents = Math.round((numericAmount + Number.EPSILON) * 100);
  const roundedCents = Math.floor(cents / BANK_DEPOSIT_ROUNDING_INCREMENT_CENTS) *
    BANK_DEPOSIT_ROUNDING_INCREMENT_CENTS;

  return roundedCents / 100;
};

export const calculateCashReconciliation = ({
  openingFloat = 0,
  cashSales = 0,
  cashRefunds = 0,
  countedCash = 0,
  leaveAmount,
} = {}) => {
  const openingFloatAmount = toCurrencyNumber(openingFloat);
  const countedCashAmount = toCurrencyNumber(countedCash);
  const targetFloatAmount = Number.isFinite(Number(leaveAmount))
    ? toCurrencyNumber(leaveAmount)
    : openingFloatAmount;
  const expectedCashAmount = toCurrencyNumber(
    openingFloatAmount + toCurrencyNumber(cashSales) - toCurrencyNumber(cashRefunds)
  );
  const cashVarianceAmount = toCurrencyNumber(countedCashAmount - expectedCashAmount);
  const bankDepositAmount = roundBankDepositAmount(countedCashAmount - targetFloatAmount);
  const actualFloatAmount = toCurrencyNumber(countedCashAmount - bankDepositAmount);
  const floatDifferenceAmount = toCurrencyNumber(actualFloatAmount - targetFloatAmount);

  return {
    openingFloatAmount,
    expectedCashAmount,
    countedCashAmount,
    targetFloatAmount,
    bankDepositAmount,
    actualFloatAmount,
    cashVarianceAmount,
    floatDifferenceAmount,
  };
};
